<template>
  <div class="login-container">
    <div class="login-wrapper">
      <img :src="getAssetImageUrl('common/logos/zoom.svg')" alt="zoom-logo" class="zoom-logo move-up" />

      <div class="wrapper-contents fade-in">
        <div class="wrapper-sconchat">
          <p class="small accent">Interpreted by</p>
          <img
            :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')"
            alt="sconchat-logo"
            class="sconchat-logo"
          />
        </div>
        <p>
          Zoom 입장 코드를 입력하고 SconChat 동시 통역이 제공되는 온라인 회의에
          참여하세요.
        </p>
        <div class="wrapper-code">
          <input
            v-for="(item, index) in codes"
            :key="index"
            v-model="codes[index]"
            type="text"
            class="input-code"
            maxlength="1"
            inputmode="text"
            autocomplete="one-time-code"
            pattern="[A-Za-z0-9]"
            @input="onInput(index, $event)"
            @keydown.backspace="onBackspace(index, $event)"
            ref="inputs"
          />
        </div>
      </div>

      <div class="wrapper-contents fade-in">
      <ButtonProcess full-width> Zoom 입장하기 </ButtonProcess>

      <div class="zoom-error">
        <IconInfo class="icon-error" />
        <p class="small error">
          에러메세지를 입력 해 주세요.
        </p>
      </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import IconInfo from '@/components/icons/IconInfo.vue';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';

const { t } = useI18n({ useScope: 'global' });

const codes = ref(Array(11).fill(''));
const inputs = ref<HTMLInputElement[]>([]);

const onInput = (index: number, e: Event) => {
  const input = e.target as HTMLInputElement;
  let value = input.value;

  // 영어 + 숫자만 허용
  value = value.replace(/[^a-zA-Z0-9]/g, '');

  // 한 글자만 유지
  const lastChar = value.slice(-1);
  codes.value[index] = lastChar;

  // input 실제 값도 강제로 동기화 (한글 완전 차단)
  input.value = lastChar;

  // 다음 input으로 이동
  if (lastChar && index < inputs.value.length - 1) {
    inputs.value[index + 1].focus();
  }
};

const onBackspace = (index: number, e: KeyboardEvent) => {
  if (!codes.value[index] && index > 0) {
    inputs.value[index - 1].focus();
  }
};
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  justify-content: center;
  align-items: center;
  margin: auto 1rem;
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 25rem;
  margin-bottom: 5rem;
  gap: 1rem;
}

.wrapper-sconchat {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.sconchat-logo {
  height: 1.5rem;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

.zoom-logo {
  height: 1.5rem;
  margin-bottom: 0.5rem;
  align-self: flex-start;
}

.wrapper-contents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.wrapper-code {
  display: flex;
  width: 100%;
  gap: 0.125rem;
}

.input-code {
  padding: 0.5rem !important;
  width: 1.5rem !important;
  min-height: 2rem !important;
  border-radius: 4px;
}

.input-code:nth-child(3) {
  margin-right: 0.25rem;
}

.input-code:nth-child(7) {
  margin-right: 0.25rem;
}

.zoom-error {
  display: flex;
  gap: 0.25rem;
  align-items: flex-start;

  .icon-error {
    margin-top: 0.125rem;
  }
}

@include respond-from(tablet) {
  .login-container {
    width: 100%;
    height: 100dvh;
    background: var(--surface-background);
    margin: unset;
  }

  .login-wrapper {
    width: fit-content;
    max-width: 30rem;
    margin: 0 auto;
    padding: 2.5rem 2rem 2rem 2rem;
    border-radius: 8px;
    background-color: var(--surface-default);
    box-shadow: $shadow-modal;
  }

  .wrapper-code {
    gap: 0.25rem;
  }

  .input-code:nth-child(3) {
    margin-right: 0.5rem;
  }

  .input-code:nth-child(7) {
    margin-right: 0.5rem;
  }
}
</style>
